export default __webpack_public_path__ + "static/media/rednote-icon.d9c0c4dd.png";